module.exports = __webpack_public_path__ + "img/92343689736ed078f61981277ee26ec0.png";